export default function boardDurationValidator(duration?: number) {
  if (!duration) {
    return 'Длительность не может быть пустым';
  }
  if (duration <= 0) {
    return 'Длительность не может быть меньше или равна 0';
  }
  return undefined;
}
